interface NettleLogoProps {
  width?: number;
  className?: string;
}

export function NettleLogo({ width = 2452, className = "" }: NettleLogoProps) {
  // Original dimensions from the SVG
  const originalWidth = 2452;
  const originalHeight = 702;

  // Calculate height to maintain aspect ratio
  const height = (width / originalWidth) * originalHeight;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 2452 702"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1948.33 701.78C1804.21 701.78 1717.52 601.415 1717.52 457.287C1717.52 313.158 1804.21 220.088 1941.04 220.088C2062.37 220.088 2145.42 304.041 2150.89 438.14C2151.8 452.728 2150.89 459.11 2149.97 473.698H1822.44C1823.35 555.827 1866.21 624.21 1944.69 624.21C1990.27 624.21 2031.37 598.68 2041.4 540.257H2146.33C2128.09 647.004 2050.52 701.709 1948.33 701.709V701.78ZM2044.14 413.452C2040.49 333.147 1992.17 298.5 1941.04 298.5C1906.39 298.5 1878.06 311.265 1858 334.059C1836.12 355.941 1824.26 413.452 1889.91 413.452H2044.07H2044.14Z"
        fill="currentColor"
      />
      <path
        d="M1572.97 39.4209H1672.42V689.017H1572.97V39.4209Z"
        fill="currentColor"
      />
      <path
        d="M805.967 701.78C661.838 701.78 575.15 601.415 575.15 457.287C575.15 313.158 661.838 220.088 798.672 220.088C920.007 220.088 1003.05 304.041 1008.52 438.14C1009.43 452.728 1008.52 459.11 1007.61 473.698H680.073C680.985 555.827 723.838 624.21 802.32 624.21C847.908 624.21 889.008 598.68 899.037 540.257H1003.96C985.724 647.004 908.154 701.709 805.967 701.709V701.78ZM901.702 413.452C898.055 333.147 849.731 298.5 798.602 298.5C763.955 298.5 735.621 311.265 715.562 334.059C693.68 355.941 681.826 413.452 747.473 413.452H901.632H901.702Z"
        fill="currentColor"
      />
      <path
        d="M0.599609 39.4209H137.434L342.721 414.366C366.427 458.13 412.997 445.366 412.997 403.425L412.085 39.4209H516.096V689.017H380.173L173.064 313.16C150.27 271.219 104.611 285.807 104.611 324.101V689.017H0.599609V39.4209Z"
        fill="currentColor"
      />
      <path
        d="M1492.59 309.512C1457.03 309.512 1434.17 329.57 1434.17 367.935V538.574C1434.17 608.85 1477.02 637.115 1546.39 607.027V682.773C1495.33 711.038 1421.41 707.391 1381.29 672.744C1347.55 642.656 1334.79 599.733 1334.79 563.262V365.269C1334.79 329.711 1312.91 309.652 1278.19 309.652H1225.45C1190.8 309.652 1168.85 329.711 1168.85 365.269V538.645C1168.85 608.92 1211.7 637.185 1281.06 607.097V682.843C1230.01 711.108 1156.08 707.461 1115.96 672.814C1082.23 642.726 1069.46 599.803 1069.46 563.332V368.075C1069.46 329.781 1046.67 309.652 1011.04 309.652H1007.39V232.994H1012.87C1047.51 232.994 1069.46 212.935 1069.46 177.376V111.659L1165.27 31.3539H1168.92V177.306C1168.92 212.865 1190.8 232.924 1225.52 232.924H1278.26C1312.91 232.924 1334.86 212.865 1334.86 177.306V111.589L1430.66 31.2837H1434.31V158.089C1434.31 199.399 1467.83 232.924 1509.14 232.924H1529.2V309.582H1492.73L1492.59 309.512Z"
        fill="currentColor"
      />
      <path
        d="M2147.1 199V57.16H2098.14V31H2228.46V57.16H2179.5V199H2147.1ZM2256.69 199V31H2295.33L2346.21 135.88L2396.61 31H2435.25V199H2402.85V86.2L2358.93 175.72H2333.25L2289.09 86.44V199H2256.69Z"
        fill="currentColor"
      />
    </svg>
  );
}
